import { createSelector } from '@reduxjs/toolkit';

const accountSelector = ({ account }) => account;

export const isIncludesDefaultCustomerSelector = createSelector(
  accountSelector,
  ({ includesDefault }) => includesDefault,
);

export const userSelector = createSelector(accountSelector, ({ user }) => user);
export const accessTokenSelector = createSelector(
  userSelector,
  ({ access_token: accessToken }) => accessToken,
);

export const nexwayStateSelector = createSelector(
  accountSelector,
  ({ nexwayState }) => nexwayState || {},
);

export const nexwaySelectedCustomer = createSelector(
  nexwayStateSelector,
  (nexwayState) => nexwayState.selectedCustomer,
);

export const customerIdSelector = createSelector(
  accountSelector,
  ({ nexwayState }) => nexwayState?.selectedCustomer?.id || '',
);

export const customerNameSelector = createSelector(
  accountSelector,
  ({ nexwayState }) => nexwayState?.selectedCustomer?.name || '',
);

export const customSampleSelector = createSelector(
  accountSelector,
  ({ nexwayState }) => nexwayState.customSample || {},
);

export const crudHelperSelector = createSelector(
  nexwayStateSelector,
  ({ crudHelper }) => crudHelper || {},
);
